var r = /* @__PURE__ */ ((O) => (O[O.TEXT_INPUT = 1] = "TEXT_INPUT", O[O.DROPDOWN = 2] = "DROPDOWN", O[O.CHECKBOX = 3] = "CHECKBOX", O))(r || {});
const N = {
  1: "input",
  2: "dropdown",
  3: "checkbox"
};
export {
  r as CheckoutFieldType,
  N as CheckoutFieldTypeNameMap
};
//# sourceMappingURL=checkout.types.js.map
